import React from "react";
import "./LuxuryTrip.css";
import MaldivesPrivateVilla from "../../assets/MaldivesPrivateVilla.png";
import DubaiRoyalExperience from "../../assets/DubaiRoyalExperience.png";
import SwissLuxuryRetreat from "../../assets/SwissLuxuryRetreat.png";
import ParisEliteGetaway from "../../assets/ParisEliteGetaway.png";
import BaliPremiumResortStay from "../../assets/BaliPremiumResortStay.png";
import SantoriniLuxuryEscape from "../../assets/SantoriniLuxuryEscape.png";
import { useNavigate } from "react-router-dom";

const luxuryTrips = [
  {
    title: "Maldives Private Villa",
    image: MaldivesPrivateVilla,
    description:
      "Indulge in a luxurious Maldives escape featuring private overwater villas, crystal clear lagoons, and personalized butler service. Enjoy fine dining experiences, sunset cruises, and relaxing spa treatments in an exclusive tropical paradise.",
    link: "/tour-package-data",
  },
  {
    title: "Dubai Royal Experience",
    image: DubaiRoyalExperience,
    description:
      "Experience unmatched luxury in Dubai with five star hotels, private yacht tours, and premium desert safaris. Explore iconic landmarks, designer shopping destinations, and gourmet dining for an unforgettable royal getaway.",
    link: "/tour-package-data",
  },
  {
    title: "Swiss Luxury Retreat",
    image: SwissLuxuryRetreat,
    description:
      "Escape to the Swiss Alps in elegant chalets surrounded by breathtaking mountain scenery. Enjoy scenic train journeys, world class hospitality, and intimate fine dining experiences in a peaceful alpine paradise.",
    link: "/tour-package-data",
  },
  {
    title: "Paris Elite Getaway",
    image: ParisEliteGetaway,
    description:
      "Discover Paris in style with luxury suites, private city tours, and exclusive dining experiences. Enjoy romantic river cruises, designer boutiques, and iconic landmarks while embracing sophistication and elegance.",
    link: "/tour-package-data",
  },
  {
    title: "Bali Premium Resort Stay",
    image: BaliPremiumResortStay,
    description:
      "Relax in a private pool villa in Bali surrounded by lush greenery and ocean views. Experience personalized spa treatments, candlelight dinners, and premium hospitality for a serene and luxurious escape.",
    link: "/tour-package-data",
  },
  {
    title: "Santorini Luxury Escape",
    image: SantoriniLuxuryEscape,
    description:
      "Enjoy breathtaking sunsets from cliffside suites in Santorini with infinity pools and world class service. Savor Mediterranean cuisine, explore charming villages, and experience unmatched luxury in a stunning island setting.",
    link: "/tour-package-data",
  },
];

const LuxuryTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="luxury-container">
      <h2 className="luxury-title">Luxury Trip Packages</h2>

      <div className="luxury-grid">
        {luxuryTrips.map((trip, index) => (
          <div
            className="luxury-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="luxury-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LuxuryTrip;
